/** Copyright ©2026 Drivepoint */

import ClaudeLogo from "../../../assets/genai/claude.svg";
import GeminiLogo from "../../../assets/genai/gemini.svg";
import OpenAILogo from "../../../assets/genai/openai.png";
import "./GenAIProviderIcon.css";

const LOGOS: Record<string, string> = {
  anthropic: ClaudeLogo,
  openai: OpenAILogo,
  google: GeminiLogo,
  vertexai: GeminiLogo
};

export default function GenAIProviderIcon({provider}: {provider: string}) {
  const src = LOGOS[provider];
  if (!src) {
    return <div className="gen-ai-provider-icon gen-ai-provider-icon-fallback">?</div>;
  }
  return <div className="gen-ai-provider-icon">
    <img src={src} alt={provider} />
  </div>;
}
